<template>
  <div class="two">
    <news more-url="/main?type=1&selected=8&page=1" style="width:860px" url="home/HomeGetSzNews" :param="{top:8,type:2}" text="专题报道" />
    <oneCol more-url="/main?type=1&selected=4&page=1" style="flex:1;margin-left:20px" url="home/HomeGetSzNews" :param="{top:4,type:3}" text="政策法规" />
  </div>
</template>

<script>
import news from '../leftImgNews.vue'
import oneCol from '../oneCol.vue'
export default {
  components: {
    news, oneCol
  },
  data() {
    return {
    }
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.two {
  display: flex;
}
.rightContent {
  img {
    width: 100%;
    height: 200px;
  }

  .twoItem {
    display: flex;
    justify-content: space-between;
    margin-top: 22px;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 199px;
      height: 132px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 8px;
      padding: 31px 0 21px 0;
    }
    .item > div > img {
      margin-right: 10px;
      width: 50px;
      height: 50px;
    }
    .item > div > span {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .item > span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
    }
  }
}
</style>
